import { render, staticRenderFns } from "./AlertsIncidentsTableItem.vue?vue&type=template&id=216dbd66&"
import script from "./AlertsIncidentsTableItem.vue?vue&type=script&lang=js&"
export * from "./AlertsIncidentsTableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports